import React, { useState } from "react";
import SlideShow from "../../components/SlideShow";

import interiorsCollection from "../../data/Paintings/interiors_Data";
import NavSpacer from "../../components/NavSpacer";
import Breadcrumbs from "../../components/Breadcrumbs";
import BackButton from "../../components/BackButton";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function Interiors() {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div>
      <Helmet>
        <title>Interiors — Paintings by Tyrone Layne</title>
        <meta property='og:image' content={interiorsCollection[0].image} />
        <link rel='canonical' href='https://tyronelayne.com/paintings/interiors' />
      </Helmet>
      <NavSpacer />
      <Breadcrumbs />
      <SlideShow
        slides={interiorsCollection}
        slideShowName='interiors'
        startingIndex={0}
        scrollOffset={-40}
      />
      <div style={{ textAlign: "center", margin: "4rem 0 2rem 0" }}>
        <Link
          to="/painting-shop"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "inline-block",
            padding: "14px 32px",
            backgroundColor: isHovered ? "#000" : "transparent",
            color: isHovered ? "#fff" : "#000",
            border: "1px solid #000",
            borderRadius: "0",
            fontSize: "0.85rem",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            textDecoration: "none",
            transition: "background-color 0.2s ease, color 0.2s ease",
            fontFamily: "inherit",
          }}
        >
          Shop available paintings
        </Link>
      </div>
      <BackButton />
    </div>
  );
}

export default Interiors;
